import { HabitSchedule } from '@griply/types';
import {
  getTimeframeOccurrences,
  GetTimeframeOccurrencesOptions,
} from '@griply/utils';
import { useMemo } from 'react';

export type Options = GetTimeframeOccurrencesOptions;

export const useTimeframeOccurrences = (
  schedules: HabitSchedule[],
  { startDate, endDate }: Options,
) =>
  useMemo(
    () => getTimeframeOccurrences(schedules, { startDate, endDate }),
    [endDate, schedules, startDate],
  );
